import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import router from "../router/index";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "vuex",
      storage: window.localStorage,
    }),
  ],
  state: {
    items: [],
    table: -1,
    order: -1,
    link: "",
    user: [],
    userOffline: [],
    userOnline: [],
    userOrderOnline: [],
    checkVaraints: [],
    businessId: null,
    api_token: null,
    swiperIndex: null,
    SortID: "",
  },
  getters: {
    getsortID: (state) => {
      return state.sortID;
    },
    foodorderItems: (state) => {
      const businessId = state.businessId;
      return state.items.filter((food) => food.businessId == businessId);
    },
    orderItems: (state) => {
      // const businessId = router.currentRoute.params.id;
      return state.items.filter(
        (product) => product.businessId == state.businessId
      );
    },
    totalPriceRes: (state, getters) => {
      const Price = getters.foodorderItems.reduce((total, food) => {
        return (
          total +
          (food.discount_percent == 0
            ? food.price.replace(/,/g, "") * food.quantity
            : (food.price.replace(/,/g, "") - food.discount) * food.quantity)
        );
      }, 0);
      return Price;
    },
    totalPrice: (state, getters) => {
      const Price = getters.orderItems.reduce((total, product) => {
        return (
          total +
          (product.discount_percent == 0
            ? product.price * product.quantity
            : (product.price - product.discount) * product.quantity)
        );
      }, 0);
      return Price;
    },
    totalPriceGold: (state, getters) => {
      const Price = getters.orderItems.reduce((total, product) => {
        return (
          total +
          (product.businessId == state.businessId
            ? product.variant.last_price
            : 0)
        );
      }, 0);
      return Price;
    },
    totalPriceShop: (state, getters) => {
      const Price = getters.orderItems.reduce((total, product) => {
        return (
          total +
          (product.discount_percent == 0
            ? product.variant.price * product.variant.quantity
            : (product.variant.price - product.discount) *
              product.variant.quantity)
        );
      }, 0);
      return Price;
    },
    packagingPrice: (state) => {
      const businessId = router.currentRoute.params.id;
      let packagePrice = 0;
      state.items
        .filter((product) => product.businessId === businessId)
        .forEach(
          (product) =>
            (packagePrice += product.packaging_price * product.quantity)
        );
      return packagePrice;
    },
    table: (state) => {
      return state.table;
    },
    order: (state) => {
      return state.order;
    },
    link: (state) => {
      return state.link;
    },
    user: (state) => {
      return state.user;
    },
    userOffline: (state) => {
      return state.userOffline;
    },
    userOnline: (state) => {
      return state.userOnline;
    },
    userOrderOnline: (state) => {
      return state.userOrderOnline;
    },
    apiToken: (state) => {
      return state.api_token;
    },
    checkVaraints: (state) => {
      return state.checkVaraints;
    },
    businessId: (state) => {
      return state.businessId;
    },
    swiperIndex: (state) => {
      return state.swiperIndex;
    },
  },
  actions: {},
  mutations: {
    restart(state, link) {
      state.order = -1;
      state.link = link;
    },
    resetTable(state) {
      state.table = -1;
    },
    setTable(state, table) {
      state.table = table;
    },
    setSortID(state, sortid) {
      state.sortID = sortid;
    },
    setUser(state, user) {
      state.user = user;
    },
    setUserOffline(state, user) {
      state.userOffline = user;
    },
    setUserOnline(state, user) {
      state.userOffline = user;
    },
    setUserResOnline(state, user) {
      state.userOnline = user;
    },
    setUserOnline(state, user) {
      state.userOrderOnline = user;
    },
    setApiToken(state, token) {
      state.api_token = token;
    },
    setCheckVaraints(state, checkVaraints) {
      state.checkVaraints = checkVaraints;
    },
    setbusinessId(state, businessId) {
      state.businessId = null;
      state.businessId = businessId;
    },
    setResName(state, name) {
      state.userOnline.name = name;
    },
    setName(state, name) {
      state.userOrderOnline.name = name;
    },
    setRestaurant(state, restaurant) {
      state.restaurant = restaurant;
    },
    setOrder(state, order) {
      state.order = order;
    },
    setbusinessId(state, businessId) {
      state.businessId = null;
      state.businessId = businessId;
    },
    setSwiperIndex(state, index) {
      state.swiperIndex = index;
    },
    clearOrder(state) {
      state.items = [];
    },
    addFoodToOrder(state, food) {
      const item = state.items.find((item) => item.id === food.id);
      if (item == null) {
        food.quantity = 1;
        state.items.push(food);
      } else {
        item.quantity++;
      }
    },
    ResincrementItemQuantity(state, food) {
      const item = state.items.find((item) => item.id === food.id);
      item.quantity++;
    },
    ResdecrementItemQuantity(state, food) {
      const item = state.items.find((item) => item.id === food.id);
      if (item && item.quantity == 1) {
        state.items.splice(state.items.indexOf(item), 1);
      } else {
        item.quantity--;
      }
    },
    addGoldToCart(state, { product, variant }) {
      // const item = state.items.find((item) => item.id === data.product.id);
      // if (item == null) {
      //   data.product.quantity = 1;
      //   data.product.show = true;
      //   data.product.variant = data.variant;
      //   state.items.push(data.product);
      // }
      // const item = state.items.find((item) => item.id === data.product.id);
      const item = state.items.find((item) =>
        item.variant ? item.variant.id === variant.id : ""
      );
      if (item == null) {
        product.quantity = 1;
        product.show = true;
        let clone = { ...product };
        clone.variant = variant;
        state.items.push(clone);
      }
    },
    addProductByVariantToCart(state, { product, variant }) {
      const item = state.items.find((item) =>
        item.variant ? item.variant.id === variant.id : ""
      );
      if (item == null) {
        // product.quantity = 1;
        if (product.type == "number") {
          variant.quantity = 1;
        } else {
          variant.quantity = 0.1;
        }
        product.show = true;
        let clone = { ...product };
        clone.variant = variant;
        state.items.push(clone);
      }
    },
    addProductToCartWithoutColor(state, product) {
      const item = state.items.find((item) => item.id === product.id);
      if (product.type == "number" && item == null) {
        product.quantity = 1;
        product.show = true;
        state.items.push(product);
      } else if (product.type == "number" && item != null) {
        item.quantity += 1;
      } else if (product.type == "kilo" && item == null) {
        product.quantity = 0.1;
        state.items.push(product);
      } else if (product.type == "kilo" && item != null) {
        item.quantity += 0.1;
      } else if (product.type == "meter" && item == null) {
        product.quantity = 0.1;
        state.items.push(product);
      } else if (product.type == "meter" && item != null) {
        item.quantity += 0.1;
      }
    },
    addProductToCart(state, { product, color }) {
      const item = state.items.find((item) =>
        item.ordercolor ? item.ordercolor.id === color.id : ""
      );
      if (product.type == "number" && item == null) {
        product.quantity = 1;
        product.show = true;
        // Spread Method
        // let clone = { ...product };
        // Object.assign() Method
        // let clone = Object.assign({}, product);
        // JSON.parse() Method
        // let clone = JSON.parse(JSON.stringify(product));
        let clone = { ...product };
        clone.ordercolor = color;
        state.items.push(clone);
      } else if (product.type == "number" && item != null) {
        item.quantity += 1;
      } else if (product.type == "kilo" && item == null) {
        product.quantity = 0.1;
        state.items.push(product);
      } else if (product.type == "kilo" && item != null) {
        item.quantity += 0.1;
      } else if (product.type == "meter" && item == null) {
        product.quantity = 0.1;
        state.items.push(product);
      } else if (product.type == "meter" && item != null) {
        item.quantity += 0.1;
      }
    },
    setQuantity(state, props) {
      const item = state.items.find((item) => item.id === props.product.id);
      item.quantity = props.quantity;
    },
    incrementItemQuantity(state, product) {
      // && product.colors.length == 0
      if (!product.color) {
        const item = state.items.find(
          (item) => item.variant.id === product.variant.id
        );
        if (product.type == "number") {
          item.variant.quantity += 1;
        } else {
          item.variant.quantity += 0.1;
        }
      } else {
        const item = state.items.find(
          (item) => item.ordercolor.id === product.ordercolor.id
        );
        if (product.type == "number") {
          item.variant.quantity += 1;
        } else {
          item.variant.quantity += 0.1;
        }
      }
    },
    incrementItemQuantityStatic(state, product) {
      // && product.colors.length == 0
      if (!product.color) {
        const item = state.items.find((item) => item.id === product.id);
        if (product.type == "number") {
          item.quantity += 1;
        } else {
          item.quantity += 0.1;
        }
      }
    },
    decrementItemQuantityStatic(state, product) {
      // && product.colors.length == 0
      if (!product.color) {
        const item = state.items.find((item) => item.id === product.id);
        if (item && item.type == "number" && item.quantity == 1) {
          state.items.splice(state.items.indexOf(item), 1);
        } else if (item && item.type == "kilo" && item.quantity == 0.1) {
          state.items.splice(state.items.indexOf(item), 1);
        } else if (item && item.type == "meter" && item.quantity == 0.1) {
          state.items.splice(state.items.indexOf(item), 1);
        } else {
          if (product.type == "number") {
            item.quantity -= 1;
          } else {
            item.quantity -= 0.1;
          }
        }
      }
    },
    decrementItemQuantity(state, product) {
      // && product.colors.length == 0
      if (!product.color) {
        const item = state.items.find(
          (item) => item.variant.id === product.variant.id
        );
        if (item && item.type == "number" && item.variant.quantity == 1) {
          state.items.splice(state.items.indexOf(item), 1);
        } else if (
          item &&
          item.type == "kilo" &&
          item.variant.quantity == 0.1
        ) {
          state.items.splice(state.items.indexOf(item), 1);
        } else if (
          item &&
          item.type == "meter" &&
          item.variant.quantity == 0.1
        ) {
          state.items.splice(state.items.indexOf(item), 1);
        } else {
          if (product.type == "number") {
            item.variant.quantity -= 1;
          } else {
            item.variant.quantity -= 0.1;
          }
        }
      } else {
        const item = state.items.find(
          (item) => item.ordercolor.id === product.ordercolor.id
        );
        if (item && item.type == "number" && item.quantity == 1) {
          state.items.splice(state.items.indexOf(item), 1);
        } else if (item && item.type == "kilo" && item.quantity == 0.1) {
          state.items.splice(state.items.indexOf(item), 1);
        } else {
          if (product.type == "number") {
            item.quantity -= 1;
          } else {
            item.quantity -= 0.1;
          }
        }
      }
    },
    removeProduct(state, product) {
      const item = state.items.find(
        (item) => item.variant.id === product.variant.id
      );
      if (item) {
        state.items.splice(state.items.indexOf(item), 1);
      }
    },
    OldRemoveProduct(state, product) {
      const item = state.items.find((item) => item.id === product.id);
      if (item && item.quantity == 1) {
        state.items.splice(state.items.indexOf(item), 1);
      }
    },
    delUser(state) {
      state.user = [];
      state.userOffline = [];
      state.userOnline = [];
      state.userOrderOnline = [];
    },
    delbussinessId(state) {
      state.businessId = null;
    },
    totalPriceGoldCustom: (state, UpdateProduct) => {
      const Price = UpdateProduct.reduce((total, variant) => {
        const item = state.items.find((item) => item.variant.id === variant.id);
        return total + (variant.id == item.variant.id ? variant.last_price : 0);
      }, 0);
      return Price;
    },
  },
});
